import React from "react";

const SidePanelTip = () => (
  <div className="p-4 border-b bg-blue-50">
    <p className="text-sm text-blue-700">
      💡 <strong>Tip:</strong> Click on any tower to see detailed surface
      temperatures for each face.
    </p>
  </div>
);

export default SidePanelTip;


